import React from 'react'

import './styles/FileIcon.scss'

const FileIcon = (props) => {
  return (
    <svg className="file-icon"
      style={props.styles || {}} height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6zm7 7V3.5L18.5 9H13z"/>
      <path d="M0 0h24v24H0z" fill="none"/>
    </svg>
)}

export default FileIcon;



// WEBPACK FOOTER //
// ./src/images/icons/FileIcon.jsx